import React from 'react';
import { Link, Text } from 'library/ui';

import ThanksForFeedback from '../components/ThanksForFeedback';
import { MainContainer, TextContainer } from '../components/Containers';

export default function SuccessfullyUpdatedPreferredWorkers() {
    return (
        <MainContainer>
            <ThanksForFeedback />
            <TextContainer>
                <Text align="center">
                    Awesome! We have successfully updated your preferred workers list. Thanks again for the review!
                </Text>
            </TextContainer>
            <Link to="/home" weight="semibold">
                Back home
            </Link>
        </MainContainer>
    );
}
